export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_CITIES = 'GET_CITIES';
export const GETTING_CITIES = 'GETTING_CITIES';
